import React, { useState, useEffect, memo, useRef } from 'react';
import { SlideTrack, Wrapper, Slide } from './AutoplaySliderStyles';

const AutoplaySlider = ({ children, speed = 43, delayTime = 3000 }) => {
	const [width, setWidth] = useState(0);
	const [time, setTime] = useState(0);
	const [slides, setSlides] = useState(2);
	const sliderRef = useRef();
	const wrapperRef = useRef();

	useEffect(() => {
		const wrapperProp = wrapperRef.current.getBoundingClientRect();
		const timeout = setTimeout(() => {
			const rectProp = sliderRef.current.getBoundingClientRect();
			const rectWidth = rectProp.width / 2;
			const slideInc = rectWidth > 1 ? Math.floor(wrapperProp.width / rectWidth) : 0;
			setSlides(2 + slideInc);
			setWidth(rectWidth);
			setTime(rectWidth / speed);
		}, delayTime);
		return () => {
			clearTimeout(timeout);
		};
	}, [speed, delayTime]);

	const childrenArr = React.Children.toArray(children);

	return (
		<Wrapper ref={wrapperRef}>
			<SlideTrack ref={sliderRef} $width={width} time={time}>
				{childrenArr.length > 0 && (
					Array(slides).fill(0).map((_, index) => childrenArr.map((child) => (
						<Slide key={child.key + index}>
							{child}
						</Slide>
					)))
				)}
			</SlideTrack>
		</Wrapper>
	);
};

export default memo(AutoplaySlider);
